export default __webpack_public_path__ + "static/media/premium@2x.8b3452ac.png";